import { BsPublicResourceManagementPage } from './BsPublicResourceManagementPage';
export default BsPublicResourceManagementPage;
